import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vueScrollTo from 'vue-scrollto';

createApp(App).use(vueScrollTo).use(router).mount('#app');
